import { useEffect, useState } from "react";
import { useBoolean } from "../../../../../hooks/use-boolean";
import useTable from "../../../../../hooks/use-table";
import { ISystem } from "../../../../../types/system";
import { AllSystemsService, SystemsService } from "../../../../../services/systems";
import { enqueueSnackbar } from "notistack";
import { IPagination } from "../../../../../types/pagination";
import { useParams } from "react-router-dom";
import { GetUserByIdService, UpdateUserSystemsService } from "../../../../../services/users";
import { ISystemBranch, IUser } from "../../../../../types/user";
import { IBranch } from "../../../../../types/branch";
import { AllBranchesService } from "../../../../../services/branches";

const useUserUpdateSystem = () => {

    const { id } = useParams();

    const loading = useBoolean();
    const table = useTable();
    const buttonDisabled = useBoolean();

    const [nameSystem, setNameSystem] = useState<string>('');
    const [systems, setSystems] = useState<ISystem[]>([]);
    const [selectedItems, setSelectedItems] = useState<ISystemBranch[]>([]);
    const [userSystems, setUserSystems] = useState<ISystemBranch[]>([]);
    const [branches, setBranches] = useState<IBranch[]>([]);
    const [systemBranches, setSystemBranches] = useState<ISystemBranch[]>([]);

    const handleCheckboxChange = (systemBranch: ISystemBranch) => {                
        setSelectedItems(prevSelectedItems => 
            prevSelectedItems.some((prev) => prev.branchId === systemBranch.branchId && prev.systemId === systemBranch.systemId)
            ? prevSelectedItems.filter(item => !(item.branchId === systemBranch.branchId && item.systemId === systemBranch.systemId))
            : [...prevSelectedItems, systemBranch]
        );
    };

    const getData = async () => {

        loading.onTrue();

        await AllSystemsService(nameSystem).then(resp => {
            setSystems(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        await AllBranchesService().then(resp => {
            setBranches(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        await GetUserByIdService(parseInt(id!)).then(resp => {            
            setUserSystems((resp.data as IUser).systemBranch!);
            setSelectedItems((resp.data as IUser).systemBranch!);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        loading.onFalse();

    }

    function checkDifferenceInArrays() {
        if (selectedItems.length !== userSystems.length) {
            buttonDisabled.onFalse();
            return;
        }
    
        const userSystemsIds = userSystems.map(item => `${item.systemId}-${item.branchId}`);
        for (const selectedItem of selectedItems) {
            const itemId = `${selectedItem.systemId}-${selectedItem.branchId}`;
            if (!userSystemsIds.includes(itemId)) {
                buttonDisabled.onFalse();
                return;
            }
        }
    
        buttonDisabled.onTrue();
    }

    const updateSystems = async () => {

        loading.onTrue();

        await UpdateUserSystemsService(parseInt(id!), selectedItems).then(resp => {
            enqueueSnackbar(resp.data.message);
            getData();
        }).catch(error => {
            loading.onFalse();
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

    }

    const getSystemBranches = () => {

        let arrSystemBranches: ISystemBranch[] = [];

        systems.map((system: ISystem) => {
            branches.map((branch: IBranch) => {
                arrSystemBranches.push({ systemId: system.id, systemName: system.name, branchId: branch.id, branchCode: branch.code, branchName: branch.name });
            })
        });

        setSystemBranches(arrSystemBranches);
    }

    useEffect(() => {
        if (systems.length > 0 && branches.length > 0) {
            getSystemBranches();
        }
    }, [systems, branches]);

    useEffect(() => {
        checkDifferenceInArrays();
        console.log(selectedItems, userSystems);
    }, [selectedItems, userSystems]);

    useEffect(() => {
        getData();
    }, [nameSystem, table.page, table.pageSize]);

    return {
        loading,
        table,
        nameSystem,
        setNameSystem,
        systems,
        handleCheckboxChange,
        selectedItems,
        buttonDisabled,
        updateSystems,
        systemBranches
    }
}

export default useUserUpdateSystem;